<!-- old -->
<template>
    <div class="table-room">
      <!-- 返回箭头 -->
      <div class="back-arrow" @click="goBack">
      </div>
      <div class="title"></div>
      <div class="line"></div>
      <div class="table-list">
        <van-empty
          v-if="tables.length==0"
          class="custom-image"
          image="https://oss.mcloud.moveclub.cn/2025/table.png"
          description="暂无桌台请“创建”或者“刷新”"
        />
        <ul>
          <li v-for="table in tables" :key="table.table_id">
            <div>
              <img src="https://oss.mcloud.moveclub.cn/2025/table.png" />
              <div>
                <div>桌台ID: {{ table.no }}</div>
                <div>创建者: {{ table.host_username }}</div>
              </div>
            </div>
            <!-- <div v-if="table.host_username === user.username">
              等待选手加入
            </div> -->
            <button 
              @click="joinTable(table)">
            </button>
          </li>
        </ul>
      </div>
      <van-popup v-model="isVisible" position="center" :style="{ width: '80%', padding: '20px' }">
        <div style="text-align: center;">
          <h3>输入房间密码</h3>
          <!-- 输入框 -->
          <van-field
            v-model="pwd"
            placeholder="请输入桌台密码"
            clearable
          />
          <!-- 确认按钮 -->
          <van-button type="info" style="margin-top: 20px;" @click="joinTable(table)">加入</van-button>
        </div>
      </van-popup>
    </div>
  </template>
  
  <script>
  import io from 'socket.io-client'
  import axios from 'axios'
  import { Empty,Popup, Field, Button } from 'vant';
  export default {
    name: 'TableRoom',
    components: {
      vanEmpty: Empty,
      vanPopup:Popup, vanField:Field, vanButton:Button
    },
    data() {
      return {
        user: {},
        socket: null,
        tables: [],
        isVisible: false, // 控制弹窗显示/隐藏
        pwd: '',
        tableid: '',
        table: {}
      }
    },
    mounted() {
      this.$nextTick(() => {
        const userStr = localStorage.getItem('user')
        if (!userStr) {
          this.$router.push('/')
          return
        }
        this.tableid = this.$route.params.tabid
        this.user = JSON.parse(userStr)
        this.socket = io.connect('https://game.api.mvsports.cn', { transports: ['websocket'] })
        this.socket.on('update_tables', ( ) => {
          console.log(data.tables)
          this.isVisible = false
          let table = []
          data.tables.forEach(item=>{  
            if(item.table_id == this.tableid) {
              let arr = item.table_id.split('-')
              item.no = arr[arr.length-1]
              table.push(item)
            }
            
          })
          this.tables = table
        })
        // 加入桌台成功后跳转到对战页面
        this.socket.on('startGame', (data) => {
          this.isVisible = false
          this.$router.push({ 
            path: '/game', 
            query: { mode: 'pvp', room: data.room, player: data.player } 
          })
        })
        this.refreshTables()
        this.socket.on('error',(err)=> {
          this.pwd = ''
          this.isVisible = false
          this.$toast.fail(err.message)
        })

        this.share()
      })
    },
    methods: {
      share() {
        var url = 'https://game.gomoku.mvsports.cn/mode'
          var shareConf = {
            title: '桌台大厅',
            path:
              '/pages/webviewsteps/index?src=' + url,
          }
          wx.miniProgram.postMessage({ data: JSON.stringify(shareConf) });
      },
      createTable() {
        this.socket.emit('create_table', { username: this.user.username, user_id: this.user.id })
      },
      joinTable(table) {
        this.table = table
        if(table.protected && this.pwd == '') {
          this.isVisible = true
          return
        }
        this.socket.emit('join_table', { username: this.user.username, user_id: this.user.id, table_id: this.tableid, password: this.pwd || null })
      },
      refreshTables() {
        axios.get('/gapi/api/tables')
          .then(res => {
            console.log(res,'refreshTables')
            res.data.tables.forEach(item=>{  
              let arr = item.table_id.split('-')
              item.no = arr[arr.length-1]
            })
            this.tables = res.data.tables
          })
          .catch(err => {
            console.error(err)
          })
      },
      goBack() {
        this.$router.push('/mode')
      }
    },
    beforeDestroy() {
      if (this.socket) {
        this.socket.disconnect()
      }
    }
  }
  </script>
  
  <style scoped>
  .table-room {
    padding: 20px;
    background: url(https://oss.mcloud.moveclub.cn/2025/bg2.jpg) no-repeat;
    background-size: cover;
    min-height: 100vh;
    display: flex;
    flex-direction: column;
    align-items: center;
    position: relative;
    padding-top: 40px;
  }
  .table-room .back-arrow {
    position: absolute;
    background: url(https://oss.mcloud.moveclub.cn/2025/back.png) no-repeat;
    background-size: 100%;
    top: 10px;
    left: 10px;
    width: 44px;
    height: 44px;
    z-index: 10;
  }
  .table-room .title{
    background: url(https://oss.mcloud.moveclub.cn/2025/%E5%A5%BD%E5%8F%8B%E5%AF%B9%E6%88%98.png) no-repeat;
    width: 178px;
    height: 59px;
    background-size: 100%;
    text-align: center;
  }
  .table-room .actions {
    margin-bottom: 20px;
    margin-top: 23px;
    display: flex;
  }
  .table-room .actions .create{
    width: 126px;
    height: 41px;
    background: url(https://oss.mcloud.moveclub.cn/2025/create.png) no-repeat;
    background-size: 100%;
    margin-right: 10px;
  }
  .table-room .actions .refresh{
    width: 126px;
    height: 41px;
    background: url(https://oss.mcloud.moveclub.cn/2025/flush.png) no-repeat;
    background-size: 100%;
    margin-right: 10px;
  }
  .table-room .line{
    width: 338px;
    height: 7px;
    background: url(https://oss.mcloud.moveclub.cn/2025/line.png) no-repeat;
    background-size: 100%;
  }
  .table-room .table-list .custom-image /deep/ .van-empty__description{
    color: rgba(146, 62, 8, 1) !important;
  }
  .table-room .table-list .custom-image /deep/ .van-empty__image{
    width: 120px !important;
    height: 78px !important;
  }
  .table-list {
    text-align: left;
    max-width: 600px;
    margin: 0 auto;
  }
  .table-list ul {
    list-style: none;
    padding: 0;
    padding-top: 24px;
  }
  .table-list li {
    box-sizing: border-box;
    padding: 5px 14px 0;
    /* border-bottom: 1px solid #ccc; */
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 14px;
    width: 335px;
    height: 70px;
    background: url(https://oss.mcloud.moveclub.cn/2025/box.png) no-repeat;
    background-size: 100%;
  }
  .table-list li>div:first-child{
    display: flex;
    align-items: center;
  }
  .table-list li>div:first-child img{
    width: 74px;
    height: 48px;
    margin-right: 5px;
  }
  .table-list li>div:first-child>div:nth-child(2){
    font-size: 15px;
    color: rgba(146, 62, 8, 1);
  }
  .table-list li>div:nth-child(2){
    color: rgba(146, 62, 8, 1);
    font-size: 12px;
  }
  .table-list button {
    background: url(https://oss.mcloud.moveclub.cn/2025/join.png) no-repeat;
    width: 91px;
    height: 22px;
    background-size: 100%;
    border-color: transparent;
    border-width: 0;
  }
  .van-popup {
    border-radius: 10px; /* 圆角效果 */
  }
  </style>
  